<template>
  <pt-customer-of-system-table class="pt-customer-manage-table__withData" ref="table" :tableLabels="tableLabels" :tableData="tableData"
   @getTableData="getTableData" :totalNumber="totalNumber" :isOutside="isOutside">
      <slot/>
  </pt-customer-of-system-table>
</template>

<script>
import PtCustomerOfSystemTable from './index'
export default {
  name: 'pt-customer-of-system-table__withData',
  components: {
    'pt-customer-of-system-table': PtCustomerOfSystemTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      if(this.paramsData.role){
        this.paramsData.role = typeof this.paramsData.role==='string'?[this.paramsData.role]: this.paramsData.role
      }
      
      let data = {
        ...this.paramsData,
        pageable: {
          page: page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('systemCustomerList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取系统用户列表失败')
      })
    },
    reload (params = {}) {
      // this.currentParams = params
      this.$refs.table.reload()
    }

  }
}
</script>
